import { defer, from, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Room } from '../models/room.model';
import { RoomTicket, TicketStatus } from '../models/ticket.model';
import { getThumb, getVideoThumb } from './image';

export const defaultTask = 'Ei tehtävävalintaa';
export const defaultTaskOnSave = 'Tehtävä';

export const maxImages = 5;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRoomTicket = (object: any): object is RoomTicket => {
  if (object == null) {
    return false;
  }
  return 'status' in object;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRoom = (object: any): object is Room => {
  if (object == null) {
    return false;
  }
  return 'id' in object;
};

export function getStatusColor(roomTicket: RoomTicket) {
  switch (roomTicket.status) {
    case TicketStatus.created:
      return 'danger';
    case TicketStatus.inProgress:
      return 'warning';
    case TicketStatus.paused:
      return 'warning';
    case TicketStatus.done:
      return 'success';
    default:
      return 'light';
  }
}

export function getPreview(rt: RoomTicket) {
  if (rt.images?.length > 0 && rt.preview$ == null) {
    return defer(() => from(getThumb(rt.images[0]))).pipe(
      map((thumb) => thumb?.thumb ?? rt.images[0]),
      shareReplay(1),
    );
  } else if (rt.videos?.length > 0 && rt.preview$ == null) {
    return from(getVideoThumb(rt.videos[0])).pipe(
      map((thumb) => thumb?.thumb ?? rt.videos[0]),
      shareReplay(1),
    );
  } else {
    return of(null);
  }
}
